import React from "react";
import { Link } from "react-router-dom";

import ShowCredentials from "../components/ShowCredentials";
import Section from "../components/primatives/Section";
import SectionHeader from "../components/primatives/SectionHeader";
import ActionButton from "../components/primatives/ActionButton";
import TagButton from "../components/primatives/TagButton";

import {
  FiMap,
  FiDisc,
  FiArrowUpCircle,
  FiLogOut,
  FiShoppingBag,
  FiLoader,
} from "react-icons/fi";

class AccountSections extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loadState: props.helpers.loadState(),
      logoutLoading: false,
    };
  }

  render() {
    const { account } = this.props;
    const { loadState } = this.state;
    const { backup } = loadState; // from localstorage.

    return (
      <div>
        {/*<Section>
          <SectionHeader>
            <FiUser /> Current User
          </SectionHeader>
          <div className="text-sm">
            You are logged in as <i>{account.name}</i>.
          </div>
        </Section>*/}
        <Section>
          <SectionHeader>
            <FiDisc /> Buy Credits
          </SectionHeader>
          <div className="text-sm mb-2">
            Credits let you <b>STORE</b> and <b>PROCESS</b> data. Pay once;
            store and read forever.
          </div>
          <Link to="/credits">
            <TagButton>
              <FiShoppingBag /> purchase credits
            </TagButton>
          </Link>
        </Section>
        <Section>
          <SectionHeader>
            <FiMap /> Audit Log
          </SectionHeader>
          <div className="text-sm mb-2">
            All of your key-value changes are publicly viewable on any EOS block
            explorer.
          </div>
          <a
            href={`https://bloks.io/account/${account.name}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <TagButton>bloks.io</TagButton>
          </a>
          <a
            href={`https://www.eosx.io/account/${account.name}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <TagButton>eosx.io</TagButton>
          </a>
          <a
            href={`https://eospark.com/account/${account.name}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <TagButton>eospark.com</TagButton>
          </a>
        </Section>
        <Section>
          <SectionHeader>
            <FiArrowUpCircle /> Key Backup
          </SectionHeader>
          <div className="text-sm mb-2">
            You can remove our backup key and take full control of your account.
            But note:
            <br />
            <br />
            <ul className="list-disc">
              <li>You become the sole account owner.</li>
              <li>You can still use put.dev as normal.</li>
              <li>We cannot help with lost passwords.</li>
            </ul>
          </div>
          <TagButton disabled>
            <FiLogOut /> eject backup key (coming soon)
          </TagButton>
        </Section>

        {backup ? (
          <Section>
            <SectionHeader>
              <FiLoader /> Last Chance!
            </SectionHeader>
            <div className="text-sm mb-4">
              You've only logged in once. This is your last chance to save
              account credentials.
            </div>

            <ShowCredentials username={account.name} privateKey={account.key} />
          </Section>
        ) : null}
        <ActionButton
          isLoading={this.state.logoutLoading}
          onClick={() => {
            this.setState({ logoutLoading: true });
            this.props.logout();
          }}
        >
          Logout
        </ActionButton>
      </div>
    );
  }
}

export default AccountSections;
